import DeleteLookalikeAudienceModal from './DeleteLookalikeAudienceModal.Container';

export default DeleteLookalikeAudienceModal;
